import CheckInIneligibleModal from './CheckInIneligibleModal';

export default CheckInIneligibleModal;
